export const data1: string[] = ['Amplio', 'Limitado', 'Básico'];
export const data2: string[] = [
  'Las opciones más económicas',
  'Las opciones más costosas',
  'Todas las opciones',
];
